import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const RESERVE_SCROLL_BAR_GAP = 'reserveScrollBarGap';
const options = {
    reserveScrollBarGap: true
};

export default {
    inserted: (el, binding) => {
        if (binding.arg && binding.arg === RESERVE_SCROLL_BAR_GAP && binding.value) {
            disableBodyScroll(el, options);
        } else if (binding.value) {
            disableBodyScroll(el);
        }
    },
    componentUpdated: (el, binding) => {
        if (binding.arg && binding.arg === RESERVE_SCROLL_BAR_GAP && binding.value) {
            disableBodyScroll(el, options);
        } else if (binding.value) {
            disableBodyScroll(el);
        } else {
            enableBodyScroll(el);
        }
    },
    unbind: el => {
        enableBodyScroll(el);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/v-body-scroll-lock/dist/directives/bsl-directive.js
// module id = null
// module chunks = 